var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"existing-account-argument"},[_c('span',[_c('img',{attrs:{"src":require('@/assets/' + _vm.image + '.svg'),"alt":""}})]),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }